import { ClientContractHubResponseDto, ClientContractHubTimelineEventDto } from '../../services/contracts/ContractService';
import {
  ClientHubPosVendaProtocoloDto,
  PosVendaProtocoloListItemDto,
  PosVendaProtocoloStatus,
  PosVendaProtocoloTipo,
  PosVendaSlaEstado,
} from '../../types/posVenda';
import { slaEstadoCanonicoFromApi } from './posVendaSlaEstado';

export function mapListItemToHubProtocolo(p: PosVendaProtocoloListItemDto): ClientHubPosVendaProtocoloDto {
  return {
    id: p.id,
    numero: p.numero,
    tipo: p.tipo,
    status: p.status,
    slaEstado: p.slaEstado,
    slaPercentualConsumido: p.slaPercentualConsumido,
    responsavelUserId: p.responsavelUserId,
    responsavelNome: p.responsavelNome,
    createdAt: p.createdAt,
  };
}

function asTipo(value: string | undefined): PosVendaProtocoloTipo {
  return (value ?? 'Outros') as PosVendaProtocoloTipo;
}

function asStatus(value: string | undefined): PosVendaProtocoloStatus {
  return (value ?? 'Aberto') as PosVendaProtocoloStatus;
}

function asSla(value: string | undefined): PosVendaSlaEstado {
  return slaEstadoCanonicoFromApi(value);
}

/** Extrai protocolos únicos da timeline do hub (contrato GettelApi #505). */
export function protocolosFromHubTimeline(
  timeline: ClientContractHubTimelineEventDto[] | undefined
): ClientHubPosVendaProtocoloDto[] {
  const byId = new Map<string, ClientHubPosVendaProtocoloDto>();
  for (const ev of timeline ?? []) {
    if (ev.eventType !== 'PosVendaProtocolo' || !ev.posVendaProtocoloId) continue;
    const id = ev.posVendaProtocoloId;
    const createdAt = ev.occurredAtUtc;
    const candidate: ClientHubPosVendaProtocoloDto = {
      id,
      numero: ev.posVendaProtocoloNumero ?? id,
      tipo: asTipo(ev.posVendaProtocoloTipo),
      status: asStatus(ev.posVendaProtocoloStatus),
      slaEstado: asSla(ev.posVendaSlaEstado),
      responsavelNome: ev.posVendaResponsavelNome ?? null,
      createdAt,
    };
    const prev = byId.get(id);
    if (!prev || createdAt.localeCompare(prev.createdAt) > 0) {
      byId.set(id, candidate);
    }
  }
  return Array.from(byId.values()).sort((a, b) => b.createdAt.localeCompare(a.createdAt));
}

export function readHubProtocolos(hub: ClientContractHubResponseDto): ClientHubPosVendaProtocoloDto[] {
  return protocolosFromHubTimeline(hub.timeline);
}
